export default "__VITE_ASSET__CFf91_kF__"